/* Draws the visible cards from the pool a product list rendered. The section
   paints twice what it shows so the draw is a real one, and CSS veils the grid
   until this runs. Covers every list on the page and any injected later. */
(function () {
  function draw(section) {
    if (section.dataset.bqShuffled) return;
    var grid = section.querySelector('.resource-list--grid');
    if (!grid) return;
    section.dataset.bqShuffled = '1';

    var count = parseInt(section.getAttribute('data-bq-shuffle-count'), 10) || 8;
    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('resource-list__item');
    });

    // Fisher-Yates.
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }

    // One fragment, so one reflow, then reveal.
    var frag = document.createDocumentFragment();
    items.forEach(function (el, index) {
      el.style.display = index < count ? '' : 'none';
      frag.appendChild(el);
    });
    grid.appendChild(frag);
    section.classList.add('bq-shuffle-ready');
  }

  function run() {
    document.querySelectorAll('[data-bq-shuffle-count]').forEach(draw);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }
  // Section Rendering swaps the list on filter or editor edits.
  document.addEventListener('shopify:section:load', run);
})();
